import React, { useEffect } from 'react';
import { schema } from './character-class.yup';
import { useSelector, useDispatch } from 'react-redux';
import {
    storeCharacterClassCardApi as storeCardApi,
    createCharacterClassCardApi as createCardApi,
} from './characterClassCardSlice';
import { useNavigate } from 'react-router-dom';
import FormTabManager from '~/pages/CardSaga/components/FormTabManager.jsx';
import { FORM_GROUPS } from './constants.character-class';
import { FormTabProvider } from '~/pages/CardSaga/components/providers/FormTabProvider';

function CharacterClassCreate() {
    const { emptyModel: initialValues, allPictures } = useSelector((state) => state.cardSaga.characterClassCard);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values, formikBag) => {
        dispatch(storeCardApi({ navigate, values, formikBag }));
    };

    const formGroups = [...FORM_GROUPS]; //as you use formGroups.shift() (which mutate the original `formGroups`) at `FormTabProvider.jsx` => `formGroups` must be cloned here else so that it is not be shift() again on next visit.
    const cardInformation = formGroups.shift();

    useEffect(() => {
        dispatch(createCardApi(navigate));
    }, []);

    return (
        <FormTabProvider
            initialValues={initialValues}
            schema={() => schema(true)}
            formGroups={formGroups}
            cardInformation={cardInformation}
            allPictures={allPictures}
        >
            <FormTabManager formSubmit={formSubmit} />
        </FormTabProvider>
    );
}

export default CharacterClassCreate;
